import React from 'react';

import { money as moneyFormat } from 'utils/format/money';
import affiliate_payment_statuses from 'data/affiliate_payment_statuses';
import Actions from './Actions';

const statusHuman = (value) => affiliate_payment_statuses.find((item) => item.value == value).label;

const columns = [
  {
    name: 'Affiliate',
    selector: (row) => row.attributes.affiliate,
    sortable: true,
  },
  {
    name: 'Date',
    selector: (row) => row.attributes.payment_date_formatted,
    sortable: true,
  },
  {
    name: 'Amount',
    selector: (row) => row.attributes.amount,
    sortable: true,
    cell: (row) => moneyFormat(row.attributes.amount, row.attributes.currency.title),
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    sortable: true,
    cell: (row) => statusHuman(row.attributes.status),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '140px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
